import { urls } from './../../config';
import authFetch from './../../utils/authFetch';

export const SETTINGS_REQUEST = 'SETTINGS_REQUEST';
export const SETTINGS_RECEIVE = 'SETTINGS_RECEIVE';

const settingsRequest = () => {
    return {
        type: SETTINGS_REQUEST
    };
};

const settingsReceive = (orderSubjects, orderTypes) => {
    return {
        type: SETTINGS_RECEIVE,
        orderSubjects,
        orderTypes
    };
};

const settingsFetch = () => {
    return dispatch => {
        dispatch(settingsRequest());
        return authFetch(urls.settings).then(json => {
            const orderSubjects = json.orders_subjects;
            const orderTypes = json.orders_types;
            dispatch(settingsReceive(orderSubjects, orderTypes));
        });
    };
};

const settingsShouldFetch = state => {
    const settings = state.settings;
    if (settings.isFetching) {
        return false;
    } else {
        return settings.didInvalidate;
    }
};

export const settingsFetchIfNeeded = () => {
    return (dispatch, getState) => {
        if (settingsShouldFetch(getState())) {
            return dispatch(settingsFetch());
        }
    };
};



// WEBPACK FOOTER //
// ./src/store/settings/actions.js